export const shouldUseTypeBasedEntityApi = () => Boolean(globalThis.useTypeBasedApi && globalThis.productSuffix);

/**
 * Returns the path/query identifier for entity routes and type-based API calls.
 * Legacy mode uses entity.id; type-based mode uses entity.type (falls back to id when type is null).
 */
export const getEntityRouteParam = entity => {
  if (!entity) return undefined;
  if (shouldUseTypeBasedEntityApi() && entity.type != null) {
    return entity.type;
  }
  return entity.id;
};

/** Wraps getEntityRouteParam for service methods that expect `{ id }` (mapArgs renames to type in v2). */
export const getEntityServiceIds = entity => ({ id: getEntityRouteParam(entity) });

/** Route param from useParams is already the correct segment value for the active API mode. */
export const getEntityServiceIdsFromRouteParam = routeParam => ({ id: routeParam });
